
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import TeamMembers from './components/TeamMembers';

export default function Team() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <TeamMembers />
      </main>
      <Footer />
    </div>
  );
}
